/**
 * Created by jiayanfeng on 2017/11/10.
 *
 */
export const Redirect_To_App_Config_Page = "App_Config_Page/Redirect_To_App_Config_Page";
export const Update_App_Config_Page_Data = "App_Config_Page/Update_App_Config_Page_Data";
export const App_Config_Input_Change = "App_Config_Page/App_Config_Input_Change";
export const App_Config_Update_Quota = "App_Config_Page/App_Config_Update_Quota";
export const App_Config_Cancel_Quota_Change = "App_Config_Page/App_Config_Cancel_Quota_Change";

